import React from "react";
import {BaseComponent} from "react-vextensions";
import {Row, Spinner, SpinnerProps, Text} from "react-vcomponents";
import {Assert, E} from "js-vextensions";

export type SpinnerForPercentProps = {
	/** Applies to val-as-% [ie. raw-value * 100]. */
	step?: number|n,
	/** Applies to val-as-% [ie. raw-value * 100]. */
	step_spin?: number|"any"|n,
	/** Applies to val-as-% [ie. raw-value * 100]. */
	step_display?: number|n,

	value: number|n,
	// temp; find/remember more generic way to integrate
	ml?: number|n, mr?: number|n, mt?: number|n, mb?: number|n,
} & Omit<SpinnerProps, "value" | "step">;

export const SpinnerForPercent = (props: SpinnerForPercentProps)=>{
	let {min, max, step, step_spin, step_display, value, onChange, onChange2, style, ml, mr, mt, mb, ...rest} = props;
	min ??= 0;
	max ??= 100;
	step_spin ??= step ?? "any";
	step_display ??= step ?? 1;
	return (
		<>
			<Spinner min={min} max={max} {...rest}
				style={E(
					ml != null && {marginLeft: ml},
					mr != null && {marginRight: mr},
					mt != null && {marginTop: mt},
					mb != null && {marginBottom: mb},
					style,
				)}
				step={step_spin}
				value={value?.ToPercent(step_display)}
				onChange={(val, e)=>{
					if (onChange) {
						return onChange(val.FromPercent(), e);
					}
				}}
				onChange2={(val, e)=>{
					if (onChange2) {
						return onChange2(val?.FromPercent() ?? null, e);
					}
				}}/>
			<Text>%</Text>
		</>
	);
};